import React from 'react';
import clsx from "clsx";
import DataTable from '../../DataTable/DataTable';

export default class ReservationRuQueueLogs extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "ru_queue_logs",
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="ru_queue_logs">
        <DataTable endpoint={this.props.reservation_segment_reservation_ru_queue_logs_data_table} date_format={this.props.date_format} time_format={this.props.time_format} inModal={true} />
      </div>);
  };
}